import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatFormFieldModule, MatIconModule, MatSelectModule } from '@angular/material';
import { FuseSharedModule } from '@fuse/shared.module';
import { FcOutlinedSelectModule } from '../../base/fc-outlined-select/fc-outlined-select.module';
import { FcFilterTypeOutlinedSelectComponent } from './fc-filter-type-outlined-select.component';


@NgModule({
  declarations: [
    FcFilterTypeOutlinedSelectComponent
  ],
  imports: [
    CommonModule,
    FuseSharedModule,
    FcOutlinedSelectModule,

    MatFormFieldModule,
    MatSelectModule,
    MatIconModule,
  ],
  exports: [
    FcFilterTypeOutlinedSelectComponent
  ]
})
export class FcFilterTypeOutlinedSelectModule { }
